import { z } from "zod";

export const PER_DIEM_RATE_2026 = 8650;

export function perDiemTotal(days: number): number {
  return PER_DIEM_RATE_2026 * days;
}

export function tripDays(startISO: string, endISO: string): number {
  const start = new Date(startISO);
  const end = new Date(endISO);
  if (end < start) return 0;
  const diff = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  return diff + 1;
}

export const createBusinessTripSchema = z
  .object({
    destination: z.string().min(1, "businessTrip.destination.error.required"),
    business_trip_reason: z.string().min(1, "businessTrip.reason.error.required"),
    start_date: z
      .date({ message: "businessTrip.startDate.error.required" })
      .nullable()
      .refine((v) => v !== null, "businessTrip.startDate.error.required"),
    end_date: z
      .date({ message: "businessTrip.endDate.error.required" })
      .nullable()
      .refine((v) => v !== null, "businessTrip.endDate.error.required"),
    days: z.number().int().min(1, "businessTrip.days.error.min"),
    advance_amount: z
      .string()
      .min(1, "businessTrip.advanceAmount.error.required")
      .refine(
        (v) => !isNaN(Number(v)) && Number(v) >= 0,
        "businessTrip.advanceAmount.error.invalid",
      ),
  })
  .refine(
    (data) => {
      if (!data.start_date || !data.end_date) return true;
      return data.end_date >= data.start_date;
    },
    {
      message: "businessTrip.endDate.error.beforeStart",
      path: ["end_date"],
    },
  );

export interface BusinessTripFormValues {
  destination: string;
  business_trip_reason: string;
  start_date: Date | null;
  end_date: Date | null;
  days: number;
  advance_amount: string;
}
